import { CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEffect, useRef, useState } from "react";
import { BsFillPersonFill, BsUpload } from "react-icons/bs";
import { useDispatch } from "react-redux";
import AlertDialogSlide from "../../../../common/components/AlertDialogSlide";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTryUpdate,
} from "../../../../common/method/handleNotificationAlert";
import { actionTypes } from "../../../../redux/notificationAlert";
import { clubmember_insert_pictuer } from "../../../../redux/profile/clubmember_insert_pictuer";

let useStyles = makeStyles({
  rootImages: {
    "&:hover .UploadImage": {
      display: "flex ",
    },
  },
  imageUser: {
    position: "relative",
    cursor: "pointer",
  },
  iconImage: {
    width: 50,
    height: 50,
  },
  gridIcon: {
    display: "none",
    opacity: "0.8",
  },
});
const typeImage = ["png", "jpg", "jpeg"];

export default function Index({
  dataUser,
  setFlagApiProfile,
  stateProfile,
  flagMenu,
}) {
  let classes = useStyles();
  let dispatch = useDispatch();

  const [image, setImages] = useState(null);
  const [open, setOpen] = useState(false);
  const [Loading, setLoading] = useState(false);

  let myRef = useRef();

  const openFile = (file) => {
    const input = file.target;
    const reader = new FileReader();

    reader.onload = function () {
      const dataURL = reader.result;
      let image = input.files[0].type;
      const fileType = detectFileType(dataURL);
      if (fileType === "unknown") {
        return dispatch({
          type: actionTypes.warning,
          textAlert: `لطفا فایل مورد نظر خود را با فرمت های (${typeImage.join(
            ","
          )}) وارد نمایید `,
        });
      }
      let data = {
        file: dataURL,
        file_type: image.split("/")[1],
        file_name: input.files[0].name,
        file_size: input.files[0].size,
      };
      setImages(data);
      myRef.current.value = null;
    };

    reader.readAsDataURL(input.files[0]);
  };

  const handelClick = (event) => {
    event.stopPropagation();
    myRef.current.click();
  };

  useEffect(() => {
    let sizeImage = 500000;
    if (typeImage.includes(image?.file_type)) {
      if (image?.file_size <= sizeImage) {
        setOpen(true);
      } else {
        if (image) {
          dispatch({
            type: actionTypes.warning,
            textAlert: `حداکثر حجم فایل بایستی 500mb می باشد `,
          });
        }
      }
    } else {
      if (image) {
        dispatch({
          type: actionTypes.warning,
          textAlert: `لطفا فایل مورد نظر خود را با فرمت های (${typeImage.join(
            ","
          )}) وارد نمایید `,
        });
      }
    }
  }, [image]);

  const submitApi = () => {
    if (!image || Loading || !stateProfile?.body) return;
    let payload = {
      data: {
        profile_picture: image?.file,
      },
    };

    setLoading(true);

    clubmember_insert_pictuer(payload)
      .then((res) => {
        let isok = handleNotificationAlertTryUpdate(res);
        if (!isok) {
          return;
        }
        setFlagApiProfile((prev) => !prev);
        setImages(null);
        setOpen(false);
      })
      .catch(() => {
        handleNotificationAlertCatch();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handelClose = () => {
    setOpen(false);
    setImages(null);
  };

  function detectFileType(base64) {
    const parts = base64.split(",");
    const base64Data = parts[1];
    const binaryString = atob(base64Data);
    const byteArray = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
      byteArray[i] = binaryString.charCodeAt(i);
    }

    if (
      byteArray[0] === 0xff &&
      byteArray[1] === 0xd8 &&
      byteArray[2] === 0xff
    ) {
      return "jpeg";
    } else if (
      byteArray[0] === 0x89 &&
      byteArray[1] === 0x50 &&
      byteArray[2] === 0x4e &&
      byteArray[3] === 0x47
    ) {
      return "png";
    } else if (
      byteArray[0] === 0xff &&
      byteArray[1] === 0xd8 &&
      byteArray[2] === 0xff &&
      byteArray[3] === 0xe0
    ) {
      return "jpg";
    } else {
      return "unknown";
    }
  }

  return (
    <div>
      {flagMenu ? (
        <div
          className={`${classes["rootImages"]} w-32 h-32 bg-gray-200 rounded-full flex justify-center items-center  `}
        >
          <div>
            {dataUser?.body?.profile_picture !== "null" &&
            dataUser?.body?.profile_picture ? (
              <img
                src={dataUser.body.profile_picture}
                style={{
                  width: "125px",
                  height: "125px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
                alt=""
              />
            ) : (
              <BsFillPersonFill size={80} color="white" />
            )}
          </div>
          <div
            onClick={(event) => handelClick(event)}
            className={`${classes["gridIcon"]} transition-all ease-in-out delay-[150] w-32 h-32 bg-gray-300 rounded-full flex justify-center items-center absolute  UploadImage cursor-pointer`}
          >
            <BsUpload size={50} />
          </div>
        </div>
      ) : (
        <div className="w-8 h-8 bg-gray-200 rounded-full flex justify-center items-center">
          {dataUser?.body?.profile_picture !== "null" &&
          dataUser?.body?.profile_picture ? (
            <img
              src={dataUser.body.profile_picture}
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
              alt=""
            />
          ) : (
            <BsFillPersonFill color="white" />
          )}
        </div>
      )}

      <input
        type="file"
        style={{ display: "none" }}
        ref={myRef}
        onChange={(event) => openFile(event)}
      />

      {open && (
        <AlertDialogSlide
          flagShow={open}
          handleCloseAlert={() => handelClose()}
          handleOkAlert={submitApi}
          data={{
            title: "ویرایش",
            description: Loading ? (
              <CircularProgress className={classes["CircularProgress"]} />
            ) : (
              "آیا از تغییر عکس پروفایل خود مطمئن می باشید؟"
            ),
          }}
        />
      )}
    </div>
  );
}
